<template>
  <div>
      <div class="bodyWrap">
         <header>
              <div class="headTop">
                  <div class="topBox">
                       <div class="headLeft fl">
                        <span>时间：2021年3月31日</span>
                        <span>星期三</span>
                      </div>
                      <div class="headRig fr">
                  <router-link  to="/login" tag="span">登录</router-link>
                           <router-link to="/register" tag="span">注册</router-link>
                      </div>
                  </div>
              </div>
              <div class="headBottom">
                 <div class="bottomBox">
                    <div class="botLeft fl">
                    <img src="../../assets/img/show/logo.png" alt="">
                  </div>
                  <div class="botdRig fr">
                    <ul class="fl headUl">
                      <li>资源管理</li>
                      <li>统计分析</li>
                      <li>返回信息网</li>
                    </ul>
                    <div class="fr headSearch">
                          <el-input v-model="input" placeholder="发现数据从这里开始"></el-input>
                          <span>
                              <img src="../../assets/img/show/search.png" alt="">
                          </span>
                    </div>
                  </div>
                 </div>
              </div>
          </header>
          <div class="banner"> 
                <img src="../../assets/img/show/banner.png" alt="">
          </div>
          <div class="main">
            <div class="title">
                 <p>当前位置：首页 > 新闻资讯 > 新闻资讯详情</p>
            </div>
            <div class="content">
               <h1>我所果树专家访问越南执行“一带一路”项目</h1>
               <div class="conOne">
                  <h2><span>资讯来源：品资所</span><span>时间： 2019-04-01</span><span>浏览量： 732</span></h2>
                  <div class="fr conLink">
                       <ul>
                         <li>
                            <img src="../../assets/img/show/ico1.png" alt="">
                            <span>分享</span>
                         </li>
                         <li>
                            <img src="../../assets/img/show/ico2.png" alt="">
                            <span>收藏</span>
                         </li>
                         <li>
                            <img src="../../assets/img/show/ico3.png" alt="">
                            <span>打印</span>
                         </li>
                       </ul>
                  </div>
               </div>
               <div class="conTwo">
                   <img src="../../assets/img/show/pic7.png" alt="">
                   <div class="conNews">
                      <p>8月12日-18日，为执行“一带一路”热带国家农业资源联合调查与开发评价项目，应越南国立农业大学邀请，中国热带农业科学院品资所高爱平研究员率芒果、香蕉、腰果等领域专家一行6人出访越南。</p> 
                      <p>专家组一行先后走访了越南国立农业大学、越南农业科学院果树蔬菜研究所、越南南方园艺研究所东南分中心、越南芹苴大学、越南国营Sofa农场、越南南方园艺研究所，访问过程中参观了越南农业科学院果树蔬菜研究所果树资源圃和组培中心、南方园艺研究所东南分中心腰果种植基地。专家组与越南各农业科研院所、大学相关科技和管理人员在芒果、香蕉、腰果、火龙果、柑橘、百香果等果树栽培生产方面进行了现场技术交流，双方同意就果树资源开发、病虫害综合防控等相关领域开展合作研究，积极推动越南与中国在热带果树资源育种、适用技术和推广，并在科教人员互访、研究生联合培养、国际合作项目联合申报等方面加深合作与交流。双方还互换了合作备忘录。</p>
                      <span>（责任编辑：未编辑）</span>
                   </div>
               </div>
            </div>
          </div>        
    <footer>
         <p>主持单位:中国热带农业科学院热带作物品种资源研究所 | 版权所有©热带作物种质资源信息网</p>
    </footer>
      </div>
  </div>
</template>
<script>
export default {
  name: "zzpList",
  data() {
    return {
     input: '',
     
    };
  },
  methods: {
  

  },
};
</script>
<style scoped>
@import "../../assets/scss/show.css";
  .bodyWrap{
    width:100%;
    margin:0 auto;
    background: #eeeeee;
  }
  .conLink ul{
  padding:0 15px;
  height: 30px;
  line-height: 30px;
  background: #fff;
      margin-top: -5px;
  }
  .conLink ul li{
    margin-right: 16px;
        display: inline-block;
  }
   .conLink ul li img{
    width: 18px;
    height: 17px;
    display: inline-block;
    vertical-align: top;
    margin-top: 6.5px;
  }.conLink ul li:last-child{
    margin-right:0;
  }
   .conLink ul li span{
      color: #2e8ee4;
      font-size: 14px;
      line-height: 30px; 
  }
  .conNews{
    width: 1114px;
    margin:40px auto 0 auto;
  }

  .conNews p{
    color: #4c4c4c;
    font-size: 16px;
    text-indent: 30px;
    line-height: 28px;
  }
   .conNews span{
    color: #666666;
    font-size: 16px;
    text-indent: 20px;
    line-height: 20px;
   text-align: right;
    display: block;
     margin-top: 48px;
  }
  .conTwo img{
      display: block;
      text-align: center;
      height: 364px;
      margin: 0 auto;
  }
  .content h1{
    font-size: 20px;
    color: #02874a;
    border-bottom:1px dashed #d9d9d9;
    padding-bottom: 28px;
    text-align: center;
  }
  .conOne{
   
    margin: 20px 20px 20px 30px;
  }
  .content h2{
     font-weight: normal;
     display: inline-block;
  }
  .content h2 span{
    font-size:16px;
    color: #7b7b7b;
    display: inline-block;
    vertical-align: top;
  }
  .content h2 span:first-child{
    margin-right: 165px;
  }
  .content h2 span:nth-of-type(2){
    margin-right: 50px;
  }
  .main{
     width: 1200px;
     margin: 0 auto;
  }
  .title{
    padding:27px 0 20px 0;
  }
  .title p{
    font-size: 12px;
    color: #666666;
  }
  .botdRig {
    margin-right: 45px;
  }
  .banner img{
    height: 150px;
    display: block;
    width: 100%;
  }
  footer{
    height: 84px;
    line-height: 84px;
    background: #4a4e53;
    margin-top: 66px;
    text-align: center;
    
  }
  footer p{
    font-size: 14px;
    color: #fff;
  }
.el-tabs__item{
    font-size: 20px;
    color:#02874a;
  }
  .bottomBox{
    width: 1200px;
     margin: 0 auto;
  }
  .headBottom{
    background:#fff;
    height: 100px;
     
  }
  .headSearch{
    height: 40px;
    margin-top: 30px;
    position: relative;
  }
  .headSearch span{
        background: #02874a;
    position: absolute;
    right: -45px;
    top: 0;
    height: 38px;
    width: 51px;
    border: 1px solid #02874a;
    border-top-right-radius: 5px;
    border-left: 0;
    border-bottom-right-radius: 5px;
  }
  .headSearch span img{
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-top: 7px;
    height: 24px;
  }
  .botLeft img{
   width: 489px;
   height: 42px;
   display: block;
   margin-top:29px;
  }
  .headUl li{
    font-size: 16px;
    color: #333333;
    display: inline-block;
    float: left;
    margin-right: 40px;
    line-height: 100px;
  }
  .topBox{
      width: 1200px;
       margin: 0 auto;
  }
  .headTop{
    background:#f1f1f1;
    height: 30px;
    line-height: 28px;
  }
  .el-input__inner{
    border: 1px solid #02874a !important;
    font-size: 14px;
  }
  .headLeft span{
    font-size: 12px;
    color: #666666;
    display: inline-block;
    margin-right: 30px;
  }
  .headRig span{
    font-size: 12px;
    color: #666666;
    margin-left: 30px;
     display: inline-block;
  }
</style>
